var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHideIcon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    fill: "none",
    viewBox: "0 0 16 17",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.333,
    d: "M7.999 3.836c-3.63 0-5.646 2.823-6.363 4.078-.147.257-.22.386-.213.578s.095.317.268.568c.853 1.238 3.17 4.11 6.308 4.11s5.454-2.872 6.308-4.11c.173-.25.26-.376.267-.568s-.065-.321-.212-.578c-.717-1.255-2.734-4.078-6.363-4.078Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.999,
    cy: 8.503,
    r: 2.667,
    fill: "currentColor"
  })));
};
export default SvgHideIcon;